<template>
  <div class="row">
    <div class="col m6">
      <br>
      <br>
      <h3 class="mb-0">
        Olá,
        <b>{{UserName}}</b>!
      </h3>
      <div class="center">
        <h4>
          <br />Seja muito bem-vind@!
        </h4>
        <p class="col m6">
          Este é o seu
          <b>dashboard</b>, através dele você poderá realizar suas simulações, verificar, fazer download e compartilhar os gráficos de cada uma delas.
        </p>
        <p
          class="col m6"
        >Não se esqueça, é claro, de que este sistema é livre e gratuito mas pode ter possíveis falhas em partes que a equipe de desenvolvimento está trabalhando.</p>
        <p class="col m12">Caso encontre algo nos avise, por favor!</p>
      </div>
    </div>
    <div class="col m6">
      <img class="responsive-img" src="/img/dashboard.svg" />
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  name: "TabInicial",
  data(){
    var user = firebase.auth().currentUser;
    return{
      UserName:user.displayName
    }
  },
  mounted(){

  }
};
</script>